import angular from 'angular';
import uiRouter from 'angular-ui-router';
import imageFormElementComponent from './imageFormElement.component';

let imageFormElementModule = angular.module('imageFormElement', [
  uiRouter
])

.component('imageFormElement', imageFormElementComponent)

.name;

export default imageFormElementModule;
